/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';

import {
  NavTitle,
  SmallIconContainer,
  SmallIconHeadlineContainer,
  SmallIconLink,
  MegaMenuColumn,
} from '../MegaMenuStyles';
import { LazyLink } from '../../../../../../../../slices/atoms';

const navigationTracking = (name, category) => {
  window.analytics.track('Web Interaction', {
    action: 'click',
    category,
    name,
  });
};

const SmallIconHeaderLinks = data =>
  data.map(item => (
    <MegaMenuColumn size="24%" key={item.secondary_title}>
      <SmallIconContainer>
        <SmallIconHeadlineContainer>
          <NavTitle className="title is-6 is-mega-menu-title">{item.secondary_title}</NavTitle>
        </SmallIconHeadlineContainer>
        {item.secondary_link_1 ? (
          <SmallIconLink
            renderAs={LazyLink}
            className="nav-item "
            href={item.secondary_link_1.url}
            url={item.secondary_link_1.url}
            key={item.secondary_text_1}
            onClick={() => {
              navigationTracking(item.secondary_tracking_name_1, item.secondary_tracking_category_1);
            }}
          >
            {item.secondary_text_1}
          </SmallIconLink>
        ) : null}
        {item.secondary_link_2 ? (
          <SmallIconLink
            renderAs={LazyLink}
            className="nav-item "
            href={item.secondary_link_2.url}
            url={item.secondary_link_2.url}
            key={item.secondary_text_2}
            onClick={() => {
              navigationTracking(item.secondary_tracking_name_2, item.secondary_tracking_category_2);
            }}
          >
            {item.secondary_text_2}
          </SmallIconLink>
        ) : null}
        {item.secondary_link_3 ? (
          <SmallIconLink
            renderAs={LazyLink}
            className="nav-item "
            href={item.secondary_link_3.url}
            url={item.secondary_link_3.url}
            key={item.secondary_text_3}
            onClick={() => {
              navigationTracking(item.secondary_tracking_name_3, item.secondary_tracking_category_3);
            }}
          >
            {item.secondary_text_3}
          </SmallIconLink>
        ) : null}
        {item.secondary_link_4 ? (
          <SmallIconLink
            renderAs={LazyLink}
            className="nav-item "
            href={item.secondary_link_4.url}
            url={item.secondary_link_4.url}
            key={item.secondary_text_4}
            onClick={() => {
              navigationTracking(item.secondary_tracking_name_4, item.secondary_tracking_category_4);
            }}
          >
            {item.secondary_text_4}
          </SmallIconLink>
        ) : null}
        {item.secondary_link_5 ? (
          <SmallIconLink
            renderAs={LazyLink}
            className="nav-item "
            href={item.secondary_link_5.url}
            url={item.secondary_link_5.url}
            key={item.secondary_text_5}
            onClick={() => {
              navigationTracking(item.secondary_tracking_name_5, item.secondary_tracking_category_5);
            }}
          >
            {item.secondary_text_5}
          </SmallIconLink>
        ) : null}
        {item.secondary_link_6 ? (
          <SmallIconLink
            renderAs={LazyLink}
            className="nav-item "
            href={item.secondary_link_6.url}
            url={item.secondary_link_6.url}
            key={item.secondary_text_6}
            onClick={() => {
              navigationTracking(item.secondary_tracking_name_6, item.secondary_tracking_category_6);
            }}
          >
            {item.secondary_text_6}
          </SmallIconLink>
        ) : null}
      </SmallIconContainer>
    </MegaMenuColumn>
  ));

export default SmallIconHeaderLinks;

SmallIconHeaderLinks.propTypes = {
  data: PropTypes.node.isRequired,
};
